// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubModal-cls1_GLS","cls2":"ImpactHubModal-cls2_MfE ImpactHubModal-cls1_GLS"};